import * as Sentry from '@sentry/nextjs';

export function formatFromSeconds(totalSeconds: number): string {
  let seconds = Math.abs(totalSeconds);
  const hours = Math.floor(seconds / 60 / 60);
  seconds -= hours * 60 * 60;
  const minutes = Math.floor(seconds / 60);
  seconds -= minutes * 60;

  let formatted = totalSeconds < 0 ? '-' : '';
  if (hours) formatted += `${hours}h `;
  if (minutes || (hours && seconds)) formatted += `${minutes}m `;
  if (seconds || (!hours && !minutes)) formatted += `${seconds}s`;
  return formatted.trim();
}

export function timestampFromHundredths(total: number): string {
  try {
    let remaining = Math.abs(total);
    const hours = Math.floor(remaining / 100 / 60 / 60);
    remaining -= hours * 60 * 60 * 100;
    const minutes = Math.floor(remaining / 100 / 60);
    remaining -= minutes * 60 * 100;
    const secondsParts = (remaining / 100).toString().split('.');

    return (
      hours.toString().padStart(2, '0') +
      ':' +
      minutes.toString().padStart(2, '0') +
      ':' +
      secondsParts[0].padStart(2, '0') +
      '.' +
      (secondsParts[1] || '0').padEnd(2, '0')
    );
  } catch (e) {
    reportError(e);
    return '';
  }
}

export function hoursFromNow(hours: number): Date {
  const date = new Date();
  date.setHours(date.getHours() + hours);
  return date;
}

export function minutesFromNow(minutes: number): Date {
  const date = new Date();
  date.setMinutes(date.getMinutes() + minutes);
  return date;
}

export function minutesAgo(minutes: number): Date {
  const date = new Date();
  date.setMinutes(date.getMinutes() - minutes);
  return date;
}

export function minutesSince(date: Date): number {
  return (Date.now() - date.getTime()) / 1000 / 60;
}

export function secondsSince(date: Date): number {
  return (Date.now() - date.getTime()) / 1000;
}

export function classNames(...classes: string[]): string {
  return classes.filter(Boolean).join(' ');
}

export function hasCookie(name: string): boolean {
  return (
    typeof document === 'object' &&
    document.cookie &&
    document.cookie.includes(name)
  );
}

export function generateId(): string {
  const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNPQRSTUVWXYZ123456789';
  let id = '';

  for (let i = 0; i < 20; i++) {
    const charIndex = Math.floor(Math.random() * chars.length);
    id = id + chars.charAt(charIndex);
  }

  return id;
}

export function reportError(e: string | Error): void {
  if (location.hostname === 'localhost') {
    console.error(e);
  } else {
    Sentry.captureException(e);
  }
}
